import { put, call } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/infoHistory';
import { get } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getInfoHistory({ payload }) {
  try {
    const report = yield call(get, `/piece/actions/${payload.pieceNumId}`);
    yield put(action.getInfoHistorySuccess(report));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getInfoHistoryFail());
  }
}
